import PropTypes from 'prop-types';
import { CoordinatesShape } from '../../map/models/Coordinates';

const UncoveredArea = {
  type: PropTypes.string,
  coordinates: PropTypes.arrayOf(CoordinatesShape),
  visible: PropTypes.bool,
};

export const UncoveredAreaShape = PropTypes.shape(UncoveredArea);
export const UncoveredAreaExact = PropTypes.exact(UncoveredArea);
